import { useState, useEffect, useContext } from "react";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.css";
import "../www/style.css";

import {PieChart,DonutChart} from 'amazing-react-charts'
import Select from "react-select";
import { NavLink as RRNavLink } from "react-router-dom";
import { CLOSE_IMAGE } from "../Image";
import {DATATABLE_USUARIOS} from "../Datatables";
import { UsuariosModal,DeleteModal} from "../Modal";
import StoreContext from "../Store/Context";
import {MDBIcon,MDBTabs,MDBTabsItem,MDBTabsLink, MDBTabsContent,MDBTabsPane,MDBInput,MDBBtn,MDBTextArea} from "mdb-react-ui-kit";

import { get_compania,put_compania,get_usr_usuario, post_usr_usuario, put_usr_usuario,put_usr_usuario_sts,get_compania_all,folios_restantes} from "../Services";
import { Container, Label, Row, Col, NavLink,Button,ButtonGroup } from "reactstrap";
import { error } from "jquery";
export const ConpaniaP = () => {
  const [iconsActive, setIconsActive] = useState("tab1");
  const handleIconsClick = (value) => {
    if (value === iconsActive) {
      return;
    }
    setIconsActive(value);
  };

  return (
    <>
     <Container fluid className="font-s12px">
      <Row>
        <Col xs={12} className="text-start">
          <MDBTabs className="d-flex-none custom-navs">
            <Row>
              <Col xs={12} className="col-btn-reportes">
                <MDBTabsLink className="btn-reporte_x tabs-btns" onClick={() => handleIconsClick("tab1")} active={iconsActive === "tab1"}>
                  <MDBIcon fas icon="building" className="me-2" /> Compañia
                </MDBTabsLink>
                <MDBTabsLink className="btn-reporte_x tabs-btns" onClick={() => handleIconsClick("tab2")} active={iconsActive === "tab2"}>
                  <MDBIcon fas icon="user-alt" className="me-2" /> Usuarios
                </MDBTabsLink>
                <MDBTabsLink className="btn-reporte_x tabs-btns" onClick={() => handleIconsClick("tab3")} active={iconsActive === "tab3"}>
                  <MDBIcon fas icon="file-upload" className="me-2" /> Folios FE
                </MDBTabsLink>
                <NavLink className="btn-reporte_x tabs-btns" tag={RRNavLink} to="/user/home">
                  <img src={CLOSE_IMAGE} className="src-image-x" alt="..."/>
                </NavLink>
              </Col>
            </Row>
            </MDBTabs>
        </Col>
      </Row>

      <MDBTabsContent>
        <MDBTabsPane show={iconsActive === "tab1"} className="overflow-c">
          <Compania />
        </MDBTabsPane>
        <MDBTabsPane show={iconsActive === "tab2"}>
          <Usuarios />
        </MDBTabsPane>
        <MDBTabsPane show={iconsActive === "tab3"}>
          <Folios />
        </MDBTabsPane>
      </MDBTabsContent>
     </Container>
       
    </>
  );
};
function Compania() {
    const { dataCompania } = useContext(StoreContext);
  const [error, setError] = useState("");
  const [dataObjCompania, setObjCompania] = useState([]);
  const [sucursalSelected, setSucursal] = useState("");
  const [dataCompaniaObj, setDataCompania] = useState({
    com_id:"",
    com_nombre: "",
    com_alias:"",
    com_ruc: "",
    com_dv: "",
    com_direccion: "",
    com_telefono: "",
    com_telefono2: "",
    com_email: "",
    com_fax: "",
    com_web: "",
    com_info_interes:"",
    com_cotizacion_info:"",
    com_cot_image:"",
    com_res_image:"",
    com_instagram:"",
    com_tiktok:"",
    com_facebook:"",
    com_existencia_v:""
  });

  const onClickUpdateCompania = () => {
    var body = {
      com_nombre: dataCompaniaObj.com_nombre,
      com_alias:dataCompaniaObj.com_alias,
      com_ruc: dataCompaniaObj.com_ruc,
      com_dv: dataCompaniaObj.com_dv,
      com_direccion: dataCompaniaObj.com_direccion,
      com_telefono: dataCompaniaObj.com_telefono,
      com_telefono2: dataCompaniaObj.com_telefono2,
      com_email: dataCompaniaObj.com_email,
      com_fax: dataCompaniaObj.com_fax,
      com_web: dataCompaniaObj.com_web,
      com_info_interes:dataCompaniaObj.com_info_interes,
      com_cotizacion_info:dataCompaniaObj.com_cotizacion_info,
      com_cot_image:dataCompaniaObj.com_cot_image,
      com_instagram:dataCompaniaObj.com_instagram,
      com_tiktok:dataCompaniaObj.com_tiktok,
      com_facebook:dataCompaniaObj.com_facebook,
      com_id:dataCompaniaObj.com_id,
      com_existencia_v:dataCompaniaObj.com_existencia_v
    };

    var result = put_compania(body);
    result.then((data) => {
      setError("");
      if(data===true)
        fetchCompania();
      else
        setError("ERROR "+data);
    })
  };
  async function fetchCompania() {
    var response;
    var result;
    var flag_result = false;
    // if(usr_perfil==="1"){
      response = await get_compania_all();
      setObjCompania(response);
      if(dataCompaniaObj.com_id.length>0){
      result = response.filter((data)=>{
        if(data.com_id === dataCompaniaObj.com_id){
            flag_result = false;
            return data
        }
        return null
      })
      }
      else{
        result = response[0];
        flag_result = true;
      }
      if(!flag_result){
        result = result[0];
      }
       setDataCompania({
        com_nombre: result.com_nombre,
        com_alias:result.com_alias,
        com_ruc: result.com_ruc,
        com_dv: result.com_dv,
        com_direccion: result.com_direccion,
        com_telefono: result.com_telefono,
        com_telefono2: result.com_telefono2,
        com_email: result.com_email,
        com_fax: result.com_fax,
        com_web: result.com_web,
        com_info_interes:result.com_info_interes,
        com_cotizacion_info:result.com_cotizacion_info,
        com_cot_image:result.com_cot_image,
        com_instagram:result.com_instagram,
        com_tiktok:result.com_tiktok,
        com_facebook:result.com_facebook,
        com_id:result.com_id,
        com_existencia_v:result.com_existencia_v
      });
      setSucursal(result.com_alias)
  }

  function onChange(event) {
    const { value, name } = event.target;
    setDataCompania({
      ...dataCompaniaObj,
      [name]: value,
    });
  }

  useEffect(() => {
    fetchCompania();
  }, []);

  const handleOnChangeCheckBox = (event) => {
    const { value, name } = event.target;
    setDataCompania({
      ...dataCompaniaObj,
      [name]:value==="0"?"1":"0"
  })};
  var objCompania = []
    dataObjCompania.map((comp) => {
    objCompania.push({
      value: comp.com_id,
      label: comp.com_alias,
    });
    return comp;
  });
  const onChangeDropdown = (selectedOptions) => {
    dataObjCompania.find((data)=>{
      if(data.com_id === selectedOptions.value){
        setDataCompania({
          com_nombre: data.com_nombre,
          com_alias: data.com_alias,
          com_ruc: data.com_ruc,
          com_dv: data.com_dv,
          com_direccion: data.com_direccion,
          com_telefono: data.com_telefono,
          com_telefono2: data.com_telefono2,
          com_email: data.com_email,
          com_fax: data.com_fax,
          com_web: data.com_web,
          com_info_interes:data.com_info_interes,
          com_cotizacion_info:data.com_cotizacion_info,
          com_cot_image:data.com_cot_image,
          com_instagram:data.com_instagram,
          com_tiktok:data.com_tiktok,
          com_facebook:data.com_facebook,
          com_id:data.com_id,
          com_existencia_v:data.com_existencia_v
        })
      }
    })
  };

  return (
    <fluid className="company-config-page font-s12px">
      <Row>
        {/* <Col sm={12} md={6} >
        <Label className="error-label">{error.length > 0 ? error : ""}</Label>
        </Col> */}
           <Col sm={8} md={3} className="mb-1 mt-1">
           {objCompania.length>1?          <Select
            options={objCompania}
            onChange={onChangeDropdown}
            placeholder={sucursalSelected}
          />:""}

        </Col>
        <Col  sm={4} md={3} >
          <MDBBtn className="mb-4" type="submit" block onClick={() => onClickUpdateCompania()}>
          <MDBIcon fas icon="save" className="me-1" /> Guardar
          </MDBBtn>
        </Col>
      </Row>
      <Row className="mt-1">
        <Col sm={6} md={6}  className="input-tablet">
          <MDBInput
            id="com_nombre"
            name="com_nombre"
            wrapperClass={window.innerWidth <= 611?"mb-2":"mb-3"}
            label="Razón Social"
            onChange={onChange}
            value={dataCompaniaObj.com_nombre}
            disabled={true}
          />
        </Col>
        <Col sm={6} md={6}  className="input-tablet">
          <MDBInput
            id="com_alias"
            name="com_alias"
            wrapperClass={window.innerWidth <= 611?"mb-2":"mb-3"}
            label="Razón comercial"
            onChange={onChange}
            value={dataCompaniaObj.com_alias}
            disabled={true}
          />
        </Col>
        <Col xs={9} sm={4} md={3}  className="input-tablet">
          <MDBInput
            id="com_ruc"
            name="com_ruc"
            wrapperClass={window.innerWidth <= 611?"mb-2":"mb-3"}
            label="RUC"
            onChange={onChange}
            value={dataCompaniaObj.com_ruc}
            disabled={true}
          />
        </Col>
        <Col xs={3} sm={2} md={3}  className="input-tablet">
          <MDBInput
            id="com_dv"
            name="com_dv"
            wrapperClass={window.innerWidth <= 611?"mb-2":"mb-3"}
            label="DV"
            onChange={onChange}
            value={dataCompaniaObj.com_dv}
            disabled={true}
          />
        </Col>
        <Col  sm={6} md={6}  className="input-tablet">
          <MDBInput
            id="com_web"
            name="com_web"
            wrapperClass={window.innerWidth <= 611?"mb-2":"mb-3"}
            label="Pagina Web"
            onChange={onChange}
            value={dataCompaniaObj.com_web}
          />
        </Col>
        <Col sm={6} md={6}  className="input-tablet">
          <MDBInput
            id="com_email"
            wrapperClass={window.innerWidth <= 611?"mb-2":"mb-3"}
            name="com_email"
            label="EMAIL"
            onChange={onChange}
            value={dataCompaniaObj.com_email}
          />
        </Col>
      </Row>
      <Row >
        <Col  xs={6} sm={4} md={2}  className="input-tablet">
          <MDBInput
            id="com_telefono"
            name="com_telefono"
            wrapperClass={window.innerWidth <= 611?"mb-2":"mb-3"}
            label="Teléfono"
            onChange={onChange}
            value={dataCompaniaObj.com_telefono}
          />
        </Col>
        <Col xs={6}  sm={4} md={2}  className="input-tablet">
          <MDBInput
            id="com_telefono2"
            name="com_telefono2"
            wrapperClass={window.innerWidth <= 611?"mb-2":"mb-3"}
            label="Teléfono 2"
            onChange={onChange}
            value={dataCompaniaObj.com_telefono2}
          />
        </Col>
        <Col xs={6}  sm={4} md={2}  className="input-tablet">
          <MDBInput
            id="com_fax"
            name="com_fax"
            wrapperClass={window.innerWidth <= 611?"mb-2":"mb-3"}
            label="FAX"
            onChange={onChange}
            value={dataCompaniaObj.com_fax}
          />
        </Col>
        <Col xs={6}  sm={4} md={2}  className="input-tablet">
          <MDBInput
            id="com_facebook"
            name="com_facebook"
            label="Facebook"
            onChange={onChange}
            value={dataCompaniaObj.com_facebook}
          />
        </Col>
        <Col xs={6}  sm={4} md={2}  className="input-tablet">
          <MDBInput
            id="com_instagram"
            name="com_instagram"
            wrapperClass={window.innerWidth <= 611?"mb-2":"mb-3"}
            label="Instagram"
            onChange={onChange}
            value={dataCompaniaObj.com_instagram}
          />
        </Col>
        <Col xs={6}   sm={4} md={2}>
          <MDBInput
            id="com_tiktok"
            wrapperClass={window.innerWidth <= 611?"mb-2":"mb-3"}
            name="com_tiktok"
            label="TikTok"
            onChange={onChange}
            value={dataCompaniaObj.com_tiktok}
          />
        </Col>
      </Row>
      <Row className={window.innerWidth <= 611?"mb-2":"mb-3"}>
        {dataCompania.com_version==="2" &&<Col   sm={4} md={2}  className="input-tablet">
          <Label>¿Facturar sin existencia?</Label>
         <ButtonGroup>
        
            <Button
              color="primary"
              
              onClick={() => setDataCompania({...dataCompaniaObj,com_existencia_v:"1"})}
              active={dataCompaniaObj.com_existencia_v === "1"?true:false}
            >
             SI
            </Button>
            <Button
              color="primary"
              onClick={() => setDataCompania({...dataCompaniaObj,com_existencia_v:"0"})}
              active={dataCompaniaObj.com_existencia_v === "0"?true:false}
            >
             NO
            </Button>
          </ButtonGroup>
        </Col>}
        
        <Col  sm={8} md={10} className="input-tablet">
          <MDBTextArea 
            id="com_direccion"
            name="com_direccion"
            rows={2}
            label="Dirección"
            onChange={onChange}
            value={dataCompaniaObj.com_direccion}
          />
        </Col>
        </Row>
      <Row className="mb-1">
        <Col  sm={12} md={12}  className="input-tablet">
          <MDBTextArea 
            id="com_info_interes"
            name="com_info_interes"
            label="Información en la factura"
            rows={window.innerWidth <= 611?2:5} 
            onChange={onChange}
            value={dataCompaniaObj.com_info_interes}
          />
        </Col>
      </Row>
      <Row >
        <Col  sm={12} md={12} className="mb-2 input-tablet">
          <div className="form-check form-check-inline">
            <input className="form-check-input" type="checkbox" name="com_cot_image" id="inlineRadioReporte" value={dataCompaniaObj.com_cot_image} 
              onChange={handleOnChangeCheckBox}  checked={dataCompaniaObj.com_cot_image==="1"?true:false}/>
            <label className="form-check-label" htmlFor="inlineRadioReporte">Mostrar cotización con imagen</label>
          </div>
        </Col>
        <Col  sm={12} md={12}  className="input-tablet">
          <MDBTextArea 
            id="com_cotizacion_info"
            name="com_cotizacion_info"
            label="Información en la cotizaciones"
            rows={window.innerWidth <= 611?2:4} 
            onChange={onChange}
            value={dataCompaniaObj.com_cotizacion_info}
          />
        </Col>
      </Row>
      
    </fluid>
  );
}
function Usuarios() {
  const [basicModal, setBasicModal] = useState(false);
  const [basicModalDelete, setBasicModalDelete] = useState(false);
  const [basicModalEdit, setBasicModalEdit] = useState(false);
  const [isLoadingU, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [dataUsuarios, setDataUsuarios] = useState([]);
  const [formUsuarios, setFormUsuarios] = useState({
    usr_id: "",
    usr_usuario: "",
    usr_clave: "",
    usr_nombre: "",
    usr_perfil: "",
    usr_sucursal: "",
    usr_print:"",
    usr_company:"",
    usr_ajustes:"",
    usr_factura:"",
    usr_inventario:"",
    usr_cotizacion:"",
    usr_articulo:"",
    usr_reporte:"",
    usr_a_costo:"",
    usr_apartado:"",
    usr_gastos:"",
    usr_gastos:"",
    dataCompaniaObj:[],
    cajaData:[],
    usr_clientes:"",
    usr_precio:""
  });

  const onClickUpdateUsuarios = () => {
    setLoading(true)
    var body ={
       usr_id: formUsuarios.usr_id,
        usr_usuario: formUsuarios.usr_usuario,
    usr_clave:  formUsuarios.usr_clave,
    usr_nombre:  formUsuarios.usr_nombre,
    usr_perfil:  formUsuarios.usr_perfil,
    usr_sucursal:  formUsuarios.usr_sucursal,
    usr_print: formUsuarios.usr_print,
    usr_company: formUsuarios.usr_company,
    usr_ajustes: formUsuarios.usr_ajustes,
    usr_factura: formUsuarios.usr_factura,
    usr_inventario: formUsuarios.usr_inventario,
    usr_cotizacion: formUsuarios.usr_cotizacion,
    usr_articulo: formUsuarios.usr_articulo,
    usr_reporte: formUsuarios.usr_reporte,
    usr_a_costo:formUsuarios.usr_a_costo,
    usr_apartado: formUsuarios.usr_apartado,
    usr_gastos:formUsuarios.usr_gastos,
    usr_clientes: formUsuarios.usr_clientes,
    usr_precio: formUsuarios.usr_precio,
    }
    var result = put_usr_usuario(body);
    result.then((data) => {
      setError("");
      if(data===true){
        setLoading(false)
        fetchUsuarios();
      }
      else
        setError("ERROR "+data);
    });
  };

  const onClickUpdateUsuario_sts = () => {
    var body = {
      usr_id: formUsuarios.usr_id,
      usr_sts: 0,
    };
    var result = put_usr_usuario_sts(body);
    result.then((data) => {
      setError("");
      if(data===true)
        fetchUsuarios();
      else
        setError("ERROR "+data);
    });
  };

  const onClickSaveUsuarios = () => {
    setLoading(true)
    if (
      formUsuarios.usr_usuario.length > 0 &&
      formUsuarios.usr_clave.length > 0 &&
      formUsuarios.usr_nombre.length > 0 &&
      formUsuarios.usr_print.length >0
    ) {
      var result = post_usr_usuario(formUsuarios);
      result.then((data) => {
        setError("");
        if(data===true){
          setLoading(false);
          fetchUsuarios();
        }
         
        else
          setError("ERROR "+data);
      });
    } else {
      setError("Campos importantes estan vacios");
    }
  };

  async function fetchUsuarios() {
    setLoading(true);
    var response;
    response = await get_usr_usuario();
    setDataUsuarios(response);
    setBasicModal(false);
    setBasicModalDelete(false);
    setBasicModalEdit(false)
    setLoading(false);
    setError("");
  }

  function onChange(event) {
    const { value, name } = event.target;
    setFormUsuarios({
      ...formUsuarios,
      [name]: value,
    });
    setError("");
  }

  useEffect(() => {
    fetchUsuarios();
  }, []);

  const onChangeDropdown = (selectedOptions) => {
    if(selectedOptions.objName==="print"){
      setFormUsuarios({
        ...formUsuarios,
        usr_print:selectedOptions.value
    })
    }
    else{
      setFormUsuarios({
        ...formUsuarios,
        usr_perfil:selectedOptions.value
    })
    }
    };

    const handleOnChangeCheckBox = (event) => {
      const { value, name } = event.target;
      setFormUsuarios({
        ...formUsuarios,
        [name]:value==="0"?"1":"0"
    })
    };
  return (
    <Container  fluid className="font-s12px">
      {basicModal && (
        <UsuariosModal
          props={formUsuarios}
          isOpen={basicModal}
          basicModalEdit={basicModalEdit}
          toggle={setBasicModal}
          toggleSave={onClickSaveUsuarios}
          toggleSaveEdit={onClickUpdateUsuarios}
          onChange={onChange}
          error={error}
          onChangeDropdown={onChangeDropdown}
          handleOnChangeCheckBox={handleOnChangeCheckBox}
          loading={isLoadingU}
        />
      )}
      {basicModalDelete && (
        <DeleteModal
          props={formUsuarios.usr_nombre}
          isOpen={basicModalDelete}
          toggle={setBasicModalDelete}
          toggleDelete={onClickUpdateUsuario_sts}
          text={"Eliminar este registro?"}
          error={error}
        />
      )}
      <Row>
      <Col className="modal-add-inventario datatable-factura css_datatable1">
        <DATATABLE_USUARIOS dataUsuarios ={dataUsuarios} 
        setBasicModalDelete={setBasicModalDelete}
        setFormUsuarios={setFormUsuarios}
        setBasicModal={setBasicModal}
        setBasicModalEdit={setBasicModalEdit}
        setError={setError}
        fetchUsuarios={fetchUsuarios}
        isLoadingU={isLoadingU} />
        </Col>
      </Row>
    </Container>
  );
}
function Folios() {
  const [dataFolios, setDataFolios] = useState([]);
  async function fetchFolios() {
    var response = await folios_restantes();
    setDataFolios(response.FoliosRestantesResult);
  }

  useEffect(() => {

      fetchFolios()

  }, []);

  return (
    <Container fluid>
      {dataFolios !== undefined?     <Row>
        <Col xs={12} sm={12} md={8}>
        
          <Row className="mb-3 mt-1">
            <Col xs={3} sm={3} md={2} className="input-tablet">
              <MDBInput
                id="codigo"
                name="codigo"
                label="Código"
                disabled={true}
                value={dataFolios.codigo}
              />
            </Col>
            <Col xs={9} sm={9} md={6} className="input-tablet">
              <MDBInput
                id="mensaje"
                name="mensaje"
                label="Mensaje"
                disabled={true}
                value={dataFolios.mensaje}
              />
            </Col>
            <Col xs={6}  sm={6} md={4} className="mb-3 mt-3 input-tablet">
              <MDBInput
                id="licencia"
                name="licencia"
                label="Licencia"
                disabled={true}
                value={dataFolios.licencia}
              />
            </Col>
            <Col  xs={4} sm={4} md={2} className="mb-3 mt-3 input-tablet">
              <MDBInput
                id="resultado"
                name="resultado"
                label="Resultado"
                disabled={true}
                value={dataFolios.resultado}
              />
            </Col>
            <Col xs={2} sm={2} md={2} className="mb-3 mt-3 input-tablet">
              <MDBInput
                id="ciclo"
                name="ciclo"
                label="Ciclo"
                disabled={true}
                value={dataFolios.ciclo}
              />
            </Col>
              <Col xs={6} sm={6} md={6} className="mb-3 input-tablet">
              <MDBInput
                id="fechaCiclo"
                name="fechaCiclo"
                label="Fecha ciclo"
                disabled={true}
                value={dataFolios.fechaCiclo}
              />
            </Col>
            <Col xs={6} sm={6} md={4} className="mb-3 input-tablet">
              <MDBInput
                id="fechaLicencia"
                name="fechaLicencia"
                label="Fecha de licencia"
                disabled={true}
                value={dataFolios.fechaLicencia}
              />
            </Col>
            <Col xs={4} sm={4} md={2} className="mb-3 input-tablet">
              <MDBInput
                id="foliosDisponibleCiclo"
                name="foliosDisponibleCiclo"
                label="Folios disponibles ciclo"
                disabled={true}
                value={dataFolios.foliosDisponibleCiclo}
              />
            </Col>
            <Col xs={4} sm={4} md={2}  className="mb-3 input-tablet">
              <MDBInput
                id="foliosUtilizadosCiclo"
                name="foliosUtilizadosCiclo"
                label="Folios utilizados en el ciclo"
                disabled={true}
                value={dataFolios.foliosUtilizadosCiclo}
              />
            </Col>
            <Col xs={4} sm={4} md={2}  className="mb-3 input-tablet">
              <MDBInput
                id="foliosTotales"
                name="foliosTotales"
                label="Folios totales"
                disabled={true}
                value={dataFolios.foliosTotales}
              />
            </Col>
            <Col xs={5} sm={4} md={3}  className="mb-3 input-tablet">
              <MDBInput
                id="foliosTotalesCiclo"
                name="foliosTotalesCiclo"
                label="Folios totales ciclo"
                disabled={true}
                value={dataFolios.foliosTotalesCiclo}
              />
            </Col>
            <Col xs={7} sm={8} md={3}  className="mb-3 input-tablet">
              <MDBInput
                id="foliosTotalesDisponibles"
                name="foliosTotalesDisponibles"
                label="Folios totales disponibles"
                disabled={true}
                value={dataFolios.foliosTotalesDisponibles}
              />
            </Col>
          </Row>

        </Col>
        <Col xs={12} sm={12} md={4}>
          <PieChart
               legendType="scroll"
    colors={['#dd6864', '#5093ce', '#3366cc', '#109618', '#ff9900']}
    legendPosition="inside"
    radius="75%"
    toolboxTooltip={{ saveAsImage: 'saving'}}
    title="Folios factura electrónica"
    center={['50%', '50%']}
            data={[
              { name: 'Total', value: Number(dataFolios.foliosTotales) },
              { name: 'Total disponibles', value: Number(dataFolios.foliosTotalesDisponibles) },
              { name: 'Totales en el ciclo', value: Number(dataFolios.foliosTotalesCiclo) },
              { name: 'Utilizados en el ciclo', value: Number(dataFolios.foliosUtilizadosCiclo) },
              { name: 'Disponibles ciclo', value: Number(dataFolios.foliosDisponibleCiclo) },
            ]}
          />
        </Col>
      </Row>:""}

     
    </Container>
  );
}